"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ManagementCapabilities = void 0;
var ManagementCapabilities;
(function (ManagementCapabilities) {
    ManagementCapabilities["MODEL"] = "MODEL";
    ManagementCapabilities["SERIAL_NUMBER"] = "SERIAL_NUMBER";
    ManagementCapabilities["BRAND"] = "BRAND";
    ManagementCapabilities["OS_VERSION"] = "OS_VERSION";
    ManagementCapabilities["BATTERY_STATUS"] = "BATTERY_STATUS";
    ManagementCapabilities["STORAGE_UNITS"] = "STORAGE_UNITS";
    ManagementCapabilities["TEMPERATURE"] = "TEMPERATURE";
    ManagementCapabilities["SCREENSHOT_UPLOAD"] = "SCREENSHOT_UPLOAD";
    ManagementCapabilities["NETWORK_INFO"] = "NETWORK_INFO";
    ManagementCapabilities["WIFI"] = "WIFI";
    ManagementCapabilities["WIFI_SCAN"] = "WIFI_SCAN";
    ManagementCapabilities["WIFI_AP"] = "WIFI_AP";
    ManagementCapabilities["WIFI_STRENGTH"] = "WIFI_STRENGTH";
    ManagementCapabilities["TIMERS_PROPRIETARY"] = "TIMERS_PROPRIETARY";
    ManagementCapabilities["BRIGHTNESS_SCHEDULING"] = "BRIGHTNESS_SCHEDULING";
    ManagementCapabilities["TIMERS_NATIVE"] = "TIMERS_NATIVE";
    ManagementCapabilities["SET_BRIGHTNESS"] = "SET_BRIGHTNESS";
    ManagementCapabilities["GET_BRIGHTNESS"] = "GET_BRIGHTNESS";
    ManagementCapabilities["SCREEN_RESIZE"] = "SCREEN_RESIZE";
    ManagementCapabilities["SET_TIME"] = "SET_TIME";
    ManagementCapabilities["SET_TIMEZONE"] = "SET_TIMEZONE";
    ManagementCapabilities["GET_TIMEZONE"] = "GET_TIMEZONE";
    ManagementCapabilities["NTP_TIME"] = "NTP_TIME";
    ManagementCapabilities["APP_UPGRADE"] = "APP_UPGRADE";
    ManagementCapabilities["FIRMWARE_UPGRADE"] = "FIRMWARE_UPGRADE";
    ManagementCapabilities["PACKAGE_INSTALL"] = "PACKAGE_INSTALL";
    /**
     * Telemetry capability to notify about installed packages on the device.
     */
    ManagementCapabilities["NOTIFY_INSTALLED_PACKAGES"] = "NOTIFY_INSTALLED_PACKAGES";
    ManagementCapabilities["SET_VOLUME"] = "SET_VOLUME";
    ManagementCapabilities["GET_VOLUME"] = "GET_VOLUME";
    /**
     * Lock the device in Kiosk Mode: IR RC is disabled and the user is unable to exit our app.
     */
    ManagementCapabilities["SET_REMOTE_CONTROL_ENABLED"] = "SET_REMOTE_CONTROL_ENABLED";
    ManagementCapabilities["SET_DEBUG"] = "SET_DEBUG";
    ManagementCapabilities["SYSTEM_REBOOT"] = "SYSTEM_REBOOT";
    ManagementCapabilities["APP_RESTART"] = "APP_RESTART";
    ManagementCapabilities["DISPLAY_POWER"] = "DISPLAY_POWER";
    ManagementCapabilities["SERVLET"] = "SERVLET";
    ManagementCapabilities["HARDWARE_LED_SET_COLOR"] = "HARDWARE_LED_SET_COLOR";
    ManagementCapabilities["PROXIMITY_SENSOR"] = "PROXIMITY_SENSOR";
    ManagementCapabilities["FACTORY_RESET"] = "FACTORY_RESET";
    ManagementCapabilities["ORIENTATION_LANDSCAPE"] = "ORIENTATION_LANDSCAPE";
    ManagementCapabilities["ORIENTATION_PORTRAIT"] = "ORIENTATION_PORTRAIT";
    ManagementCapabilities["ORIENTATION_LANDSCAPE_FLIPPED"] = "ORIENTATION_LANDSCAPE_FLIPPED";
    ManagementCapabilities["ORIENTATION_PORTRAIT_FLIPPED"] = "ORIENTATION_PORTRAIT_FLIPPED";
    ManagementCapabilities["ORIENTATION_AUTO"] = "ORIENTATION_AUTO";
    ManagementCapabilities["SCHEDULE_POWER_ACTION"] = "SCHEDULE_POWER_ACTION";
    ManagementCapabilities["EXTENDED_MANAGEMENT"] = "EXTENDED_MANAGEMENT";
    ManagementCapabilities["SYSTEM_CPU"] = "SYSTEM_CPU";
    ManagementCapabilities["SYSTEM_MEMORY"] = "SYSTEM_MEMORY";
    ManagementCapabilities["PROXY"] = "PROXY";
    ManagementCapabilities["AUTO_RECOVERY"] = "AUTO_RECOVERY";
    ManagementCapabilities["PEER_RECOVERY"] = "PEER_RECOVERY";
    ManagementCapabilities["FILE_SYSTEM_WIPEOUT"] = "FILE_SYSTEM_WIPEOUT";
    ManagementCapabilities["REMOTE_DESKTOP"] = "REMOTE_DESKTOP";
    /**
     * Lock the device in Hotel Mode: IR RC keeps working but the user is still unable to exit our app.
     */
    ManagementCapabilities["HOTEL_MODE"] = "HOTEL_MODE";
    ManagementCapabilities["VPN"] = "VPN";
    /**
     * Custom scripts are used for executing custom code on the device. See {@link CustomScript}.
     */
    ManagementCapabilities["CUSTOM_SCRIPTS"] = "CUSTOM_SCRIPTS";
    /**
     * Native Commands - MDC are used for sending device specific commands
     * for controlling device specific features or settings.
     */
    ManagementCapabilities["NATIVE_COMMANDS_MDC"] = "NATIVE_COMMANDS_MDC";
    /**
     * Android: Our device management app (Core App or Cloud Control)
     * is set as the [Device Owner](https://source.android.com/docs/devices/admin#fully-managed),
     * granting it extra management capabilities depending on the OS version.
     */
    ManagementCapabilities["DEVICE_OWNER"] = "DEVICE_OWNER";
    /**
     * Android: Our device management app (Core App or Cloud Control)
     * has an active [Accessibility Service](https://developer.android.com/guide/topics/ui/accessibility/service#act-for-users),
     * granting it extra management capabilities depending on the OS version.
     */
    ManagementCapabilities["ACCESSIBILITY_SERVICE"] = "ACCESSIBILITY_SERVICE";
    /**
     * Device can automatically control connected display over the serial ports.
     * ChromeOS: Display Manager use browser Navigator Serial API to control the display on/off.
     */
    ManagementCapabilities["DISPLAY_MANAGER"] = "DISPLAY_MANAGER";
    /**
     * Device can store secrets in secured storage.
     * Is capable to encrypt and decrypt values with stored keys.
     */
    ManagementCapabilities["SECRETS"] = "SECRETS";
    /**
     * Device is capable of disabling hardware acceleration for video playback.
     */
    ManagementCapabilities["HARDWARE_ACCELERATION"] = "HARDWARE_ACCELERATION";
    /**
     * Device supports setting specific Wi-Fi code based selected country.
     */
    ManagementCapabilities["WIFI_COUNTRY"] = "WIFI_COUNTRY";
    /**
     * Android: Device supports package stopping.
     */
    ManagementCapabilities["STOP_PACKAGE"] = "STOP_PACKAGE";
    /**
     * Device can use plugins.
     */
    ManagementCapabilities["PLUGINS"] = "PLUGINS";
    /**
     * Device can use runners.
     */
    ManagementCapabilities["RUNNERS"] = "RUNNERS";
    /**
     * Native Commands - NMC are used for sending device specific commands on webos
     * for controlling device specific features or settings.
     */
    ManagementCapabilities["NATIVE_COMMANDS_NMC"] = "NATIVE_COMMANDS_NMC";
    /** Android: Can run shell commands under [UID 2000](https://developer.android.com/reference/android/os/Process#SHELL_UID). */
    ManagementCapabilities["ADB_SHELL"] = "ADB_SHELL";
    /** Android: Can run shell commands under [UID 0](https://developer.android.com/reference/android/os/Process#ROOT_UID). */
    ManagementCapabilities["ROOT_SHELL"] = "ROOT_SHELL";
    /**
     * Device supports connecting to enterprise Wi-Fi networks, which require additional configuration such as EAP method, identity, password, and certificates.
     * This capability indicates that the device can handle the necessary authentication and encryption protocols for enterprise Wi-Fi connections via JS API or native management functions.
     *
     * Usually supported protocols include EAP-TLS, EAP-PEAP, and EAP-TTLS.
     *
     * @remarks
     * This also enables Wi-Fi setup with EAP in OSD.
     */
    ManagementCapabilities["WIFI_ENTERPRISE"] = "WIFI_ENTERPRISE";
    /**
     * Android: Device supports removing third-party application user data. Implies `STOP_PACKAGE`.
     *
     * @see [DevicePolicyManager#clearApplicationUserData](https://developer.android.com/reference/android/app/admin/DevicePolicyManager#clearApplicationUserData(android.content.ComponentName,%20java.lang.String,%20java.util.concurrent.Executor,%20android.app.admin.DevicePolicyManager.OnClearApplicationUserDataListener))
     */
    ManagementCapabilities["CLEAR_PACKAGE_DATA"] = "CLEAR_PACKAGE_DATA";
    /**
     * Android: Device supports removing accounts added using `AccountManager` API.
     *
     * @see [AccountManager#removeAccount](https://developer.android.com/reference/android/accounts/AccountManager#removeAccount(android.accounts.Account,%20android.accounts.AccountManagerCallback%3Cjava.lang.Boolean%3E,%20android.os.Handler))
     *
     * @remarks
     * This concept of _an account_ significantly differs from what it usually means
     * in terms of using a computer (e.g. a user account or user profile),
     * hence the `ANDROID_` prefix to avoid confusion.
     */
    ManagementCapabilities["ANDROID_REMOVE_ACCOUNTS"] = "ANDROID_REMOVE_ACCOUNTS";
    /**
     * Device supports some form of first-party settings control,
     * e.g. Sony BRAVIA `importSettings` REST API.
     */
    ManagementCapabilities["EXTENDED_CONTROL"] = "EXTENDED_CONTROL";
    /**
     * Device supports sending raw UDP packets (e.g., for Wake-on-LAN magic packets).
     */
    ManagementCapabilities["SEND_UDP"] = "SEND_UDP";
})(ManagementCapabilities || (exports.ManagementCapabilities = ManagementCapabilities = {}));
